<template lang="pug">
  v-row
    v-col(cols="12")
      v-list-item(class="pl-0")
        v-list-item-title
          h1 Контакты
        v-list-item-action
          v-btn(
            @click="edit = !edit"
            color="success"
            rounded depressed
          )  {{ edit ? 'Сохранить' : 'Редактировать'}}
    v-col(cols="12")
      v-slide-y-reverse-transition(leave-absolute)
        div(v-if="!edit" v-html="output" key="content")
      editor(v-if="edit" :init="config" v-model="output" key="editor")
      server-data(
        v-for="(org, idx) in userData.organizations"
        :key="idx"
        :method="() => getInfo(org.id)"
        v-slot="{ serverData }"
      )
        v-divider
        v-list(two-line)
          div(v-for="(idx, item) in serverData" :key="idx")
            v-list-item(v-if="(INFO_CONTACTS_NAMES[item].display)")
              v-list-item-content
                v-list-item-title {{ serverData[item] }}
                v-list-item-subtitle {{ INFO_CONTACTS_NAMES[item].name  }}

</template>

<script>
import { mapGetters } from 'vuex';
import Editor from '@tinymce/tinymce-vue';
import { config } from '@/plugins/TinyMCE/tinymce';

const INFO_CONTACTS_NAMES = {
  address_actual: { name: 'Актуальный адресс', display: true },
  address_legal: { name: 'Юридический адресс', display: true },
  contact_person: { name: 'Контактное лицо', display: true },
  contact_phone: { name: 'Контактный телефон', display: true },
  contact_site_url: { name: 'Адрес контактного сайта', display: true },
  director_first_name: { name: 'Имя директора', display: true },
  director_patronymic: { name: 'Отчество директора', display: true },
  director_surname: { name: 'Фамилия директора', display: true },
  founder: { name: 'Учредитель', display: true },
  full_name: { name: 'Полное наименование', display: true },
  level: { name: 'Уровень подчиненности', display: true },
  link: { name: 'Ссылка на пфдо', display: true },
  payment_bill: { name: 'платежный счет', display: true },
  short_name: { name: 'Краткое наименование', display: true },
  payment_inn: { name: 'инн организации', display: true },
  type: { display: false },
  id: { display: false },
};

export default {
  name: 'Contacts',
  components: {
    Editor,
  },
  data: () => ({
    INFO_CONTACTS_NAMES,
    output: '',
    edit: false,
    config,
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
  },
  methods: {
    getInfo(id) {
      return this.$api.contacts.getInfo(id);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
